import React, { Fragment } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';

/**
 * Componente Dropdown con Headless UI + Tailwind
 * 
 * Reemplaza los dropdowns de Materialize
 */
const Dropdown = ({
  trigger,
  items = [],
  align = 'left',
  width = 'w-48',
}) => {
  const alignments = {
    left: 'left-0',
    right: 'right-0',
  };

  return (
    <Menu as="div" className="relative inline-block text-left">
      {/* Trigger del dropdown */}
      <MenuButton className="inline-flex items-center justify-center gap-x-1.5 rounded-lg bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500">
        {trigger}
        <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
      </MenuButton>

      {/* Items del dropdown */}
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <MenuItems
          className={`absolute ${alignments[align]} z-10 mt-2 ${width} origin-top-${align} rounded-lg bg-white shadow-lg ring-1 ring-black/5 focus:outline-none`}
        >
          <div className="py-1">
            {items.map((item, index) => (
              <MenuItem key={index}>
                {({ active }) => (
                  item.divider ? (
                    <div className="border-t border-gray-100 my-1" />
                  ) : (
                    <button
                      onClick={item.onClick}
                      disabled={item.disabled}
                      className={`
                        ${active ? 'bg-gray-100 text-gray-900' : 'text-gray-700'}
                        ${item.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                        ${item.danger ? 'text-red-600' : ''}
                        group flex w-full items-center px-4 py-2 text-sm
                      `}
                    >
                      {item.icon && (
                        <item.icon className="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" />
                      )}
                      {item.label}
                    </button>
                  )
                )}
              </MenuItem>
            ))}
          </div>
        </MenuItems>
      </Transition>
    </Menu>
  );
};

export default Dropdown;
